import { swiperDefaults } from '../globals.js'
import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules';
import { initMediaGalleryZoom } from './pdp--media-gallery-zoom.js';
import { bindPdpMediaGalleryVariantSwitching } from './pdp-media-gallery-variant.js';

/**
 * Product LookBook Slider
 */
const lookbookSwipers = document.querySelectorAll('[data-lookbook-gallery]')
lookbookSwipers.forEach(swiperEl => {
    const paginationEl = swiperEl.querySelector('.slider-pagination')
    
    const navigationEl = swiperEl.querySelector('.slider-navigation')
    const nextEl = navigationEl ? navigationEl.querySelector('.slider-navigation__next') : null
    const prevEl = navigationEl ? navigationEl.querySelector('.slider-navigation__prev') : null
    
    new Swiper(swiperEl, {
        ...swiperDefaults,
        pagination: {
            ...swiperDefaults.pagination,
            el: paginationEl
        },
        navigation: nextEl && prevEl ? {
            nextEl: nextEl,
            prevEl: prevEl,
            hiddenClass: 'slider-navigation--hidden',
            disabledClass: 'slider-navigation--disabled'
        } : false,
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        modules: [Pagination, Navigation, A11y]
    })
})

/**
 * Product Compare Slider
 */
const compareProductsSwiperEl = document.querySelector('.compare-products__swiper');
const compareProductsProducts = document.querySelector('.compare-products__products');

if (compareProductsSwiperEl && compareProductsProducts) {
    const compareProductsPaginationEl = compareProductsSwiperEl.querySelector('.swiper-pagination')
    const compareProductsNextEl = document.querySelector('.compare-products .swiper-button-next')
    const compareProductsPrevEl = document.querySelector('.compare-products .swiper-button-prev')
    
    const compareProductsSwiper = new Swiper(compareProductsSwiperEl, {
        ...swiperDefaults,
        pagination: {
            ...swiperDefaults.pagination,
            el: compareProductsPaginationEl
        },
        navigation: compareProductsNextEl && compareProductsPrevEl ? {
            nextEl: compareProductsNextEl,
            prevEl: compareProductsPrevEl,
            hiddenClass: 'swiper-button-hidden',
            disabledClass: 'swiper-button-disabled'
        } : false,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            1024: {
                slidesPerView: 2,
            },
        },
        modules: [Pagination, Navigation, A11y]
    });
}

/**
 * PDP Media Gallery: main Swiper + static wrapping thumbnail grid
 */
const mediaGalleryMainSwiper = document.querySelector('.pdp-media-gallery__main');
const mediaGalleryThumbnailsEl = document.querySelector('.pdp-media-gallery__thumbnails');

if (mediaGalleryMainSwiper && mediaGalleryThumbnailsEl) {
    const thumbButtons = mediaGalleryThumbnailsEl.querySelectorAll('.pdp-media-gallery__thumb');

    const setActiveThumb = (index) => {
        thumbButtons.forEach((btn, i) => {
            btn.classList.toggle('pdp-media-gallery__thumb--active', i === index);
        });
    };

    const mainPaginationEl = mediaGalleryMainSwiper.querySelector('.pdp-media-gallery__thumbnails-wrapper .slider-pagination');
    const mainNavigationEl = mediaGalleryMainSwiper.querySelector('.pdp-media-gallery__main-navigation');
    const mainNavNext = mainNavigationEl ? mainNavigationEl.querySelector('.slider-navigation__next') : null;
    const mainNavPrev = mainNavigationEl ? mainNavigationEl.querySelector('.slider-navigation__prev') : null;

    if (mediaGalleryMainSwiper.swiper) {
        mediaGalleryMainSwiper.swiper.destroy(true, true)
    }
    window.mainSwiperInstance = null

    const mainSwiper = new Swiper(mediaGalleryMainSwiper, {
        pagination: mainPaginationEl
            ? {
                  el: mainPaginationEl,
                  type: 'bullets',
                  bulletClass: 'slider-pagination__item',
                  bulletActiveClass: 'slider-pagination__item--active',
                  clickable: true
              }
            : false,
        navigation:
            mainNavNext && mainNavPrev
                ? {
                      nextEl: mainNavNext,
                      prevEl: mainNavPrev,
                      hiddenClass: 'slider-navigation--hidden',
                      disabledClass: 'slider-navigation--disabled'
                  }
                : false,
        slidesPerView: 1,
        spaceBetween: 0,
        modules: [Pagination, Navigation, A11y]
    });

    thumbButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const idx = parseInt(btn.getAttribute('data-index'), 10);
            if (!Number.isNaN(idx)) {
                mainSwiper.slideTo(idx);
            }
        });
    });

    mainSwiper.on('slideChange', () => {
        setActiveThumb(mainSwiper.activeIndex);
    });

    setActiveThumb(mainSwiper.activeIndex);

    window.mainSwiperInstance = mainSwiper;

    initMediaGalleryZoom(mediaGalleryMainSwiper, { swiper: mainSwiper });

    try {
        bindPdpMediaGalleryVariantSwitching()
    } catch {
        /* Variant binding is optional; failure must not break the PDP Swiper */
    }
}

/**
 * Product List Slider
 */
const productListSwipers = document.querySelectorAll('.product-list .swiper')
productListSwipers.forEach(swiperEl => {
    const paginationEl = swiperEl.querySelector('.slider-pagination')
    const totalProducts = paginationEl ? parseInt(paginationEl.dataset.totalProducts) : 0
    
    const swiper = new Swiper(swiperEl, {
        ...swiperDefaults,
        pagination: {
            ...swiperDefaults.pagination,
            el: paginationEl
        },
        navigation: false,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 32
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 48
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 64
            }
        },
        modules: [Pagination, A11y],
        on: {
            init: function() {
                updatePaginationVisibility(this, paginationEl, totalProducts)
            },
            resize: function() {
                updatePaginationVisibility(this, paginationEl, totalProducts)
            },
            breakpoint: function() {
                updatePaginationVisibility(this, paginationEl, totalProducts)
            }
        }
    })
    
    // Also listen for window resize events
    window.addEventListener('resize', () => {
        updatePaginationVisibility(swiper, paginationEl, totalProducts)
    })
});

/**
 * Collapsible Media Slider with Thumbnail Navigation
 */
const collapsibleMediaSliders = document.querySelectorAll('.pdp-collapsible-media-slider')
collapsibleMediaSliders.forEach(container => {
    const mainSlider = container.querySelector('.pdp-collapsible-media-slider__slider .media-slider')
    const accordions = container.querySelectorAll('.pdp-collapsible-content')
    
    if (!mainSlider) return    
    
    // Initialize main slider (always, even without thumbnails)
    const mainSliderNavigation = mainSlider.closest('.pdp-collapsible-media-slider__slider')?.querySelector('.slider-navigation')
    const mainSliderNextEl = mainSliderNavigation ? mainSliderNavigation.querySelector('.slider-navigation__next') : null
    const mainSliderPrevEl = mainSliderNavigation ? mainSliderNavigation.querySelector('.slider-navigation__prev') : null

    const paginationEl =
        container.querySelector('.pdp-collapsible-media-slider__pagination') ||
        mainSlider.querySelector('.slider-pagination')

    const mainSwiperConfig = {
        pagination: paginationEl
            ? {
                  el: paginationEl,
                  type: 'bullets',
                  bulletClass: 'slider-pagination__item',
                  bulletActiveClass: 'slider-pagination__item--active',
                  clickable: true
              }
            : false,
        navigation: mainSliderNextEl && mainSliderPrevEl ? {
            nextEl: mainSliderNextEl,
            prevEl: mainSliderPrevEl,
            hiddenClass: 'slider-navigation--hidden',
            disabledClass: 'slider-navigation--disabled'
        } : false,
        slidesPerView: 1,
        spaceBetween: 0,
        modules: [Pagination, Navigation, A11y],
        on: {
            init: function () {
                const swiper = this
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => playVideoInActiveSlide(swiper))
                })
            },
            slideChange: function () {
                pauseAllVideos(mainSlider)
                syncAccordionWithSlide(accordions, this.realIndex)
            },
            slideChangeTransitionEnd: function () {
                playVideoInActiveSlide(this)
            }
        }
    }
    
    const mainSwiper = new Swiper(mainSlider, mainSwiperConfig)
        
    initVideoControls(mainSlider)
    initCollapsibleVideoTapToToggle(mainSlider)
    
    // Sync slider with accordion clicks
    accordions.forEach((accordion, index) => {
        const trigger = accordion.querySelector('.pdp-collapsible-content__trigger')
        if (trigger) {
            trigger.addEventListener('click', () => {
                // Small delay to ensure accordion state is updated
                setTimeout(() => {
                    const isExpanded = accordion.getAttribute('data-expanded') === 'true'
                    if (isExpanded) {
                        mainSwiper.slideTo(index)
                    }
                }, 10)
            })
        }
    })
})

/**
 * Sync accordion with active slide
 */
function syncAccordionWithSlide(accordions, activeIndex) {
    accordions.forEach((accordion, index) => {
        const trigger = accordion.querySelector('.pdp-collapsible-content__trigger')
        const content = accordion.querySelector('.pdp-collapsible-content__content')
        
        if (!trigger || !content) return
        
        // Expand the accordion corresponding to the active slide
        if (index === activeIndex) {
            accordion.setAttribute('data-expanded', 'true')
            trigger.setAttribute('aria-expanded', 'true')
            content.classList.add('pdp-collapsible-content__content--expanded')
        } else {
            // Collapse other accordions
            accordion.setAttribute('data-expanded', 'false')
            trigger.setAttribute('aria-expanded', 'false')
            content.classList.remove('pdp-collapsible-content__content--expanded')
        }
    })
}

/**
 * Media Slider (standalone)
 */
const mediaSliderSwipers = document.querySelectorAll('.media-slider:not(.pdp-collapsible-media-slider .media-slider)')
mediaSliderSwipers.forEach(swiperEl => {
    const desktopItemsPerPage = parseInt(swiperEl.dataset.desktopItemsPerPage) || 1
    const mobileItemsPerPage = parseInt(swiperEl.dataset.mobileItemsPerPage) || 1
    const displayGapBetweenItems = swiperEl.dataset.displayGapBetweenItems === 'true'
    const paginationEl = swiperEl.querySelector('.slider-pagination')
    const totalSlides = paginationEl ? parseInt(paginationEl.dataset.totalProducts) : 0
    
    const navigationEl = swiperEl.querySelector('.slider-navigation')
    const nextEl = navigationEl ? navigationEl.querySelector('.slider-navigation__next') : null
    const prevEl = navigationEl ? navigationEl.querySelector('.slider-navigation__prev') : null
    
    const swiper = new Swiper(swiperEl, {
        ...swiperDefaults,
        pagination: {
            ...swiperDefaults.pagination,
            el: paginationEl
        },
        navigation: nextEl && prevEl ? {
            nextEl: nextEl,
            prevEl: prevEl,
            hiddenClass: 'slider-navigation--hidden',
            disabledClass: 'slider-navigation--disabled'
        } : false,
        slidesPerView: mobileItemsPerPage,
        spaceBetween: displayGapBetweenItems ? 16 : 0,
        breakpoints: {
            768: {
                slidesPerView: desktopItemsPerPage
            }
        },
        modules: [Pagination, Navigation, A11y],
        on: {
            init: function() {
                updatePaginationVisibility(this, paginationEl, totalSlides)
            },
            resize: function() {
                updatePaginationVisibility(this, paginationEl, totalSlides)
            },
            breakpoint: function() {
                updatePaginationVisibility(this, paginationEl, totalSlides)
            },
            slideChange: function() {
                // Pause all videos when slide changes
                pauseAllVideos(swiperEl)
            }
        }
    })
    
    // Also listen for window resize events
    window.addEventListener('resize', () => {
        updatePaginationVisibility(swiper, paginationEl, totalSlides)
    })
    
    // Initialize video functionality
    initVideoControls(swiperEl)
})

/**
 * Initialize video controls for media slider
 */
function initVideoControls(container) {
    const playButtons = container.querySelectorAll('.media-slider__play-button')
    
    playButtons.forEach(button => {
        button.addEventListener('click', function() {
            const videoContainer = this.closest('.media-slider__video-container')
            const video = videoContainer.querySelector('.media-slider__video')
            
            if (video.paused) {
                // Pause all other videos first
                pauseAllVideos(container)
                
                // Play this video
                video.play()
                videoContainer.classList.add('media-slider__video-container--playing')
                video.classList.add('media-slider__video--playing')
            } else {
                // Pause this video
                video.pause()
                videoContainer.classList.remove('media-slider__video-container--playing')
                video.classList.remove('media-slider__video--playing')
            }
        })
    })
    
    // Pause videos when they end
    const videos = container.querySelectorAll('.media-slider__video')
    videos.forEach(video => {
        video.addEventListener('ended', function() {
            const videoContainer = this.closest('.media-slider__video-container')
            videoContainer.classList.remove('media-slider__video-container--playing')
            this.classList.remove('media-slider__video--playing')
        })
    })
}

/**
 * Autoplay video in the active slide (collapsible block slides).
 * Browsers often block play() while the <video> is invisible (opacity 0); show first, then play.
 */
function playVideoInActiveSlide(swiper) {
    if (!swiper || !swiper.slides || swiper.slides.length === 0) return

    const activeSlide = swiper.slides[swiper.activeIndex]
    if (!activeSlide) return

    const video = activeSlide.querySelector('.media-slider__video')
    const videoContainer = activeSlide.querySelector('.media-slider__video-container')
    if (!video || !videoContainer) return

    const onFail = () => {
        videoContainer.classList.remove('media-slider__video-container--playing')
        video.classList.remove('media-slider__video--playing')
    }

    video.muted = true
    video.setAttribute('playsinline', '')

    videoContainer.classList.add('media-slider__video-container--playing')
    video.classList.add('media-slider__video--playing')

    const p = video.play()
    if (p && typeof p.then === 'function') {
        p.catch(onFail)
    }
}

/**
 * Tap poster/video to pause or resume when play button is hidden (collapsible autoplay UI).
 */
function initCollapsibleVideoTapToToggle(container) {
    container.querySelectorAll('.media-slider__video-container--autoplay-ui').forEach((videoContainer) => {
        videoContainer.addEventListener('click', () => {
            const video = videoContainer.querySelector('.media-slider__video')
            if (!video) return

            if (video.paused) {
                pauseAllVideos(container)
                video.muted = true
                videoContainer.classList.add('media-slider__video-container--playing')
                video.classList.add('media-slider__video--playing')
                const p = video.play()
                if (p && typeof p.catch === 'function') p.catch(() => {})
            } else {
                video.pause()
                videoContainer.classList.remove('media-slider__video-container--playing')
                video.classList.remove('media-slider__video--playing')
            }
        })
    })
}

/**
 * Pause all videos in a container
 */
function pauseAllVideos(container) {
    const videos = container.querySelectorAll('.media-slider__video')
    const videoContainers = container.querySelectorAll('.media-slider__video-container')
    
    videos.forEach(video => {
        video.pause()
        video.classList.remove('media-slider__video--playing')
    })
    
    videoContainers.forEach(container => {
        container.classList.remove('media-slider__video-container--playing')
    })

    const youtubeIframes = container.querySelectorAll('iframe')
    youtubeIframes.forEach((iframe) => {
        if (!iframe.src || !iframe.src.includes('youtube.com')) return
        try {
            iframe.contentWindow?.postMessage(
                JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
                '*'
            )
        } catch (e) {
            // Iframe not ready or cross-origin
        }
    })
}

function updatePaginationVisibility(swiper, paginationEl, totalItems) {
    if (!paginationEl) return
    
    const currentSlidesPerView = swiper.params.slidesPerView
    const needsPagination = totalItems > currentSlidesPerView
    
    if (needsPagination) {
        paginationEl.classList.remove('hidden')
    } else {
        paginationEl.classList.add('hidden')
    }
}
